import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Hidden,
  Dialog,
  Box,
} from '@mui/material'

import closeIcon from '../../images/closeIcon.svg';


const MyMiniModal = ({isOpen, onClose, children, overflow, background, title, subTitle, topIcon, maxWidth}) => {

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={maxWidth ? maxWidth : "xs"}
        open={isOpen}
        onClose={onClose}
        PaperProps={{
          sx : {
            borderRadius:"0px",
            border:"0",
            overflow:overflow ? overflow : "auto",
          }
        }}
      >
        <Box sx={{
          paddingTop:"30px",
          paddingBottom:"40px",
          paddingLeft:"30px",
          paddingRight:"30px"
        }}>
          <Box sx={{
            display:"flex",
            flexDirection:"column",
          }}>
            <Box sx={{
              display:"flex",
              justifyContent:"flex-end"
            }}>
              <img
                src={closeIcon}
                style={{width:"18px", height:"18px", cursor:"pointer"}}
                onClick={onClose}
              />
            </Box>
            <Box sx={{
              fontSize:"30px",
              color:"text.blackTitle",
              textAlign:"center",
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:"10px",
            }}>
              {topIcon &&
                <Box sx={{
                  width:["45px", "45px", "45px", "50px"]
                }}>
                  <img src={topIcon} style={{width:"100%"}}/>
                </Box>
              }
              {title}
            </Box>
          </Box>
          <Box sx={{
            textAlign:"center",
            fontSize:"16px",
            color:"text.black",
            paddingTop:"20px",
            paddingBottom:"35px",
          }}>
            {subTitle}
          </Box>
          <Box sx={{
          }}>
            {children}
          </Box>
        </Box>
      </Dialog>
    </>
  )
}


export default MyMiniModal
